export const initialLeitenLoading = (initialStatus) => ({
    status: initialStatus || "init",
    error: undefined,
    fetchError: undefined,
    payload: undefined,
    requestId: undefined,
});
